import React, { useEffect, useRef, useState } from 'react';
import $ from 'jquery';
import { SET_GAME_BONUS_RESULT_POST } from '../../api/ApiConst';
import { callPostApi } from '../../api/ApiCaller';

const Bonus08SpinningStrawberry = ({
    keyboardInput,
    gameSessionRecordId,
    onBonusRoundCompleted,
    walletBalance,
    denomination,
}) => {
    const [isSpinning, setIsSpinning] = useState(false);
    const [hasSpun, setHasSpun] = useState(false);
    const [apiData, setApiData] = useState(null);
    const [spinFinalValue, setSpinFinalValue] = useState(0);
    const [premioValue, setPremioValue] = useState(0);
    const [apiCallFlag, setApiCallFlag] = useState(false);
    const intervalRef = useRef(null);

    const playSoundById = (id) => {
        const sound = $('#' + id)[0];
        if (!sound) return;
        sound.currentTime = 0;
        const p = sound.play();
        if (p !== undefined) p.catch(() => { });
    };
    const pauseSoundById = (id) => {
        const sound = $('#' + id)[0];
        if (!sound) return;
        if (!sound.paused) {
            sound.pause();
            sound.currentTime = 0;
        }
    };

    useEffect(() => {
        if (apiCallFlag) return;
        setApiCallFlag(true);
        callPostApi(
            SET_GAME_BONUS_RESULT_POST,
            { bonusType: 'Bonus08SpinningStrawberry', recordId: gameSessionRecordId },
            {},
            (response) => {
                if (response.errorCode === 0) {
                    setApiData(response.responsePacket);
                }
            }
        );
    }, []);

    useEffect(() => {
        if (!keyboardInput) return;
        const handleKey = (e) => {
            if (e.key.toLowerCase() === 'b') {
                startSpin();
            }
        };
        window.addEventListener('keydown', handleKey);
        return () => window.removeEventListener('keydown', handleKey);
    }, [hasSpun, apiData, keyboardInput]);

    const startSpin = () => {
        if (hasSpun || !apiData || isSpinning) return;
        setIsSpinning(true);
        setHasSpun(true);

        const bonusWon = apiData.totalBonusWinnings || 0;
        const totalWinnings = apiData.totalWinnings || 0;

        // Show final value immediately behind the strawberry
        setSpinFinalValue(bonusWon);

        // Play strawberries1.mp3 immediately
        playSoundById('PlayButtonMp3');
        playSoundById('Straw08Audio1');

        // Play strawberries12.mp3 after 4 seconds
        setTimeout(() => {
            pauseSoundById('Straw08Audio1');
            playSoundById('Straw08Audio2');
        }, 2000);

        // Update the Premio value seamlessly to integer after 2 seconds (no animation)
        setTimeout(() => {
            if (bonusWon > 0) {
                setPremioValue(Math.floor(bonusWon));
            }
        }, 1500);

        // After strawberry fully exits the frame (adjusting to 6s depending on CSS but leaving original 5s or 6s logic below if wait is long enough)
        setTimeout(() => {
            setIsSpinning(false);
            clearInterval(intervalRef.current);
            setPremioValue(bonusWon);

            setTimeout(() => { onBonusRoundCompleted(totalWinnings); }, 1000);
        }, 3000);
    };

    useEffect(() => {
        return () => { if (intervalRef.current) clearInterval(intervalRef.current); };
    }, []);


    return (
        <div className='d-flex flex-column flex-fill h-100'>
            <div>
                <img className='w-100' src="assets/img/bomba-strawberries-header-img.png" alt="" />
            </div>

            <div className='flex-fill bomba-strawberries'>
                <span className={`marquee-strawberries ${hasSpun ? 'active' : ''}`.trim()}>
                    <span style={{ width: '200px' }}>
                        <img className='img-fluid w-100' src="assets/img/bomba-strawberries.gif" alt="" />
                    </span>
                </span>
                <div className='strawberries-bonus-no'>
                    {hasSpun ? Math.floor(spinFinalValue) : ''}
                </div>
            </div>

            <div className='bomba-strawberries-footer d-flex justify-content-between align-items-center bg-black p-3 pt-1'>
                <div className='left-content'>
                    <span>aperte <span>"jogar"</span></span>
                </div>
                <span
                    className='position-relative'
                    onClick={startSpin}
                    style={{
                        opacity: hasSpun || !apiData ? 0.5 : 1,
                        pointerEvents: hasSpun || !apiData ? 'none' : 'auto',
                        cursor: hasSpun || !apiData ? 'not-allowed' : 'pointer',
                    }}
                >
                    <img className="img-fluid" src="assets/img/jogar-btn-img.png" alt="" />
                    {/* <span className="btn-red position-absolute top-0 end-0 bottom-0 start-0">
                        <span className="btn-name text-black">Jogar</span>
                    </span> */}
                </span>
                <div className="d-flex flex-column">
                    <span className='text-content text-3d'>Premio</span>
                    <span className='Premio-btn position-relative'>
                        <img className='img-fluid' src="assets/img/premio-btn-img.png" alt="" />
                        <span className='btn-text-content'>{Math.floor(premioValue)}</span>
                    </span>
                </div>
            </div>

            <audio id="Straw08Audio1" src="assets/strawberries1.mp3" />
            <audio id="Straw08Audio2" src="assets/strawberries2.mp3" />
            <audio id="PlayButtonMp3" src="assets/play-button.mp3" />

        </div>
    );
};

export default Bonus08SpinningStrawberry;
